import { ExternalConfigSpecialCourse } from '@web/store/types/modules/assets'
import anyConst from './anySpecialHome'
import takeConst from './takeSpecialHome'

const emptyDefaultConstants = {
  defaultSpecialCourseId: {} as Record<number, ExternalConfigSpecialCourse>,
  defaultSpecialCourseIdsInSubscription: {} as Record<number, number>,
  defaultPaywallServiceId: 0,
  defaultLinkQuiz: '',
  coursesForShowModalNewOffer: [],
  coursesForHideModalNewOffer: []
}

export function getSpecialHomeConst (project: 'any' | 'take') {
  if (project === 'take') {
    return takeConst
  }
  if (project === 'any') {
    return anyConst
  }

  return emptyDefaultConstants
}
